import { useQueries, useQuery } from '@tanstack/react-query';
import { cnpjsApi } from './api';
import { certificateKeys } from '@/features/certificates/hooks';
import { certificatesApi } from '@/features/certificates/api';
import type { Certificate } from '@/features/certificates/schemas';

export const cnpjsKeys = {
  all: ['cnpjs'] as const,
  list: () => ['cnpjs', 'list'] as const,
};

export function useCnpjs() {
  return useQuery({
    queryKey: cnpjsKeys.list(),
    queryFn: cnpjsApi.list,
  });
}

export function useActiveCertificates() {
  const cnpjs = useCnpjs();
  const ids = cnpjs.data?.map((c) => c.id) ?? [];
  const results = useQueries({
    queries: ids.map((id) => ({
      queryKey: certificateKeys.byCnpj(id),
      queryFn: () => certificatesApi.get(id),
    })),
  });
  const certificates = results
    .map((r) => r.data)
    .filter((c): c is Certificate => !!c);
  return {
    certificates,
    isLoading: cnpjs.isLoading || results.some((r) => r.isLoading),
  };
}
